import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import Modal from 'react-modal';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

Modal.setAppElement('#root');

const ClubDetails = () => {
    const { clubName } = useParams();
    const [club, setClub] = useState({});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImg, setSelectedImg] = useState(null);

    useEffect(() => {
        fetch('/data/clubs.json')
            .then(res => res.json())
            .then(data => setClub(data.find(item => item.type === clubName)));
    }, [clubName]);

    

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <div>
            {/* Club Header */}
            <div className='page-header h-72 flex flex-col justify-center items-center text-white text-center'>
                {club.logo && <img className='w-24 mx-auto pb-2' src={club.logo} alt="Club Logo" />}
                <h1 className='text-3xl md:text-5xl font-bold uppercase'>{club?.name}</h1>
            </div>

            {/* Club Description */}
            <div className='container mx-auto my-12 px-4 text-justify'>
                {[club.description1, club.description2, club.description3].map((desc, i) => (
                    desc && <p key={i} className='py-2'>{desc}</p>
                ))}
            </div>

            {/* Club Gallery */}
            {club.clubPhoto && club.clubPhoto.length > 0 && (
                <div className='my-12 container mx-auto px-4'>
                    <h1 className='text-center text-3xl text-secondary font-bold my-12'>CLUB <span className='text-primary'>GALLERY</span></h1>
                    
                    {/* Image Slider */}
                    <Slider {...settings} className="px-2">
                        {club.clubPhoto.map((img, i) => (
                            <div key={i} className="px-2">
                                <div 
                                    className="relative w-full h-64 flex justify-center items-center bg-gray-200 overflow-hidden group cursor-pointer rounded-lg"
                                    onClick={() => { setSelectedImg(img); setModalIsOpen(true); }}>
                                    
                                    {/* Image */}
                                    <img src={img} alt="Gallery Image" 
                                        className="w-full h-full object-cover rounded-lg transition-transform duration-300 group-hover:scale-105" />
                                    
                                    {/* Hover Overlay */}
                                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            )}

            {/* Modal for Fullscreen Image */}
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80">
                {selectedImg && (
                    <div className="relative p-4 max-w-4xl w-full">
                        <button className="absolute top-2 right-2 text-white text-3xl" 
                            onClick={() => setModalIsOpen(false)}>&times;</button>
                        <img src={selectedImg} alt="Fullscreen" className="w-full max-h-screen object-contain rounded-lg" />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default ClubDetails;
